import PropTypes from 'prop-types';
import React from 'react';

const Row = ({children, style, className}) => {
  const classes = [
    'row',
    className,
  ]
    .filter(x => !!x)
    .join(' ');

  return <div className={classes} style={style}>
    {children}
  </div>;
};

Row.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Row;
